import moment from 'moment'

/*
  Formatadores das telas públicas de consulta.

  O Intl.NumberFormat é criado uma vez no carregamento do módulo, e não a cada chamada: essas funções são
  chamadas de dentro do template, então rodam de novo em todo re-render, uma vez por valor exibido.
*/

const MOEDA = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

export function formatarParaReais(valor) {
    if (valor === null || valor === undefined) {
        return '-'
    }

    return MOEDA.format(Number(valor))
}

export function formatarData(data) {
    if (!data) {
        return '-'
    }

    return moment(data, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY HH:mm')
}
